const paletteSets = [
  { primary: "#0f172a", secondary: "#334155", accent: "#38bdf8", surface: "#f8fafc", text: "#0f172a" },
  { primary: "#1f2937", secondary: "#4b5563", accent: "#f97316", surface: "#fff7ed", text: "#111827" },
  { primary: "#14532d", secondary: "#3f6212", accent: "#84cc16", surface: "#f7fee7", text: "#14532d" },
  { primary: "#3b0764", secondary: "#6b21a8", accent: "#f472b6", surface: "#faf5ff", text: "#3b0764" },
  { primary: "#7c2d12", secondary: "#9a3412", accent: "#fb923c", surface: "#fff7ed", text: "#7c2d12" },
  { primary: "#164e63", secondary: "#0f766e", accent: "#2dd4bf", surface: "#ecfeff", text: "#083344" },
  { primary: "#312e81", secondary: "#4338ca", accent: "#818cf8", surface: "#eef2ff", text: "#312e81" },
  { primary: "#4a044e", secondary: "#a21caf", accent: "#f0abfc", surface: "#fdf4ff", text: "#581c87" },
  { primary: "#422006", secondary: "#92400e", accent: "#fbbf24", surface: "#fffbeb", text: "#451a03" },
  { primary: "#052e16", secondary: "#166534", accent: "#4ade80", surface: "#f0fdf4", text: "#052e16" },
];

const headerVariants = ["banner", "split", "centered", "stacked", "highlight"];
const sidebarVariants = ["left", "right", "none"];
const skillVariants = ["chips", "bars", "grid", "plain", "outline"];
const titleVariants = ["line", "block", "underline", "capsule", "minimal"];
const fontFamilies = [
  '"Trebuchet MS", "Segoe UI", sans-serif',
  'Georgia, "Times New Roman", serif',
  '"Gill Sans", "Segoe UI", sans-serif',
  '"Palatino Linotype", "Book Antiqua", serif',
  '"Lucida Sans", "Segoe UI", sans-serif',
];

const sectionOrders = [
  ["summary", "experience", "projects", "education", "certifications", "references"],
  ["experience", "summary", "projects", "education", "certifications", "references"],
  ["summary", "projects", "experience", "education", "certifications", "references"],
  ["summary", "experience", "education", "projects", "certifications", "references"],
  ["experience", "projects", "summary", "education", "certifications", "references"],
  ["summary", "education", "experience", "projects", "certifications", "references"],
];

const layoutPresets = [
  { headerVariant: "banner", sidebarVariant: "left", skillVariant: "bars", titleVariant: "underline", density: "compact", contactLayout: "split", sectionSurface: "soft", experienceStyle: "timeline", projectStyle: "list", sidebarTone: "tinted", titleAlign: "left", mainColumns: 1 },
  { headerVariant: "centered", sidebarVariant: "right", skillVariant: "outline", titleVariant: "block", density: "comfortable", contactLayout: "centered", sectionSurface: "outlined", experienceStyle: "cards", projectStyle: "cards", sidebarTone: "surface", titleAlign: "left", mainColumns: 1 },
  { headerVariant: "highlight", sidebarVariant: "left", skillVariant: "grid", titleVariant: "line", density: "spacious", contactLayout: "row", sectionSurface: "flat", experienceStyle: "minimal", projectStyle: "cards", sidebarTone: "dark", titleAlign: "left", mainColumns: 1 },
  { headerVariant: "stacked", sidebarVariant: "none", skillVariant: "chips", titleVariant: "minimal", density: "compact", contactLayout: "split", sectionSurface: "flat", experienceStyle: "timeline", projectStyle: "list", sidebarTone: "surface", titleAlign: "left", mainColumns: 2 },
  { headerVariant: "split", sidebarVariant: "right", skillVariant: "plain", titleVariant: "capsule", density: "comfortable", contactLayout: "stacked", sectionSurface: "soft", experienceStyle: "cards", projectStyle: "list", sidebarTone: "tinted", titleAlign: "left", mainColumns: 1 },
  { headerVariant: "banner", sidebarVariant: "none", skillVariant: "outline", titleVariant: "underline", density: "spacious", contactLayout: "centered", sectionSurface: "outlined", experienceStyle: "minimal", projectStyle: "cards", sidebarTone: "surface", titleAlign: "center", mainColumns: 2 },
];

export const templateCatalog = Array.from({ length: 30 }, (_, index) => {
  const templateNumber = index + 4;
  const palette = paletteSets[index % paletteSets.length];
  const preset = layoutPresets[index % layoutPresets.length];
  const fontFamily = fontFamilies[(index * 2 + 1) % fontFamilies.length];
  const sectionOrder = sectionOrders[(index * 5 + 2) % sectionOrders.length];

  return {
    id: `Template${templateNumber}`,
    name: `Template ${templateNumber}`,
    number: templateNumber,
    palette,
    fontFamily,
    headerVariant: preset.headerVariant,
    sidebarVariant: preset.sidebarVariant,
    skillVariant: preset.skillVariant,
    titleVariant: preset.titleVariant,
    sectionOrder,
    density: preset.density,
    contactLayout: preset.contactLayout,
    sectionSurface: preset.sectionSurface,
    experienceStyle: preset.experienceStyle,
    projectStyle: preset.projectStyle,
    sidebarTone: preset.sidebarTone,
    titleAlign: preset.titleAlign,
    mainColumns: preset.mainColumns,
    avatarShape: index % 2 === 0 ? "rounded" : "circle",
    thumbnailPattern: index % 4,
  };
});

export const dynamicTemplateIds = new Set(templateCatalog.map((template) => template.id));

export const getDynamicTemplateConfig = (templateId) =>
  templateCatalog.find((template) => template.id === templateId);
